// The result count beside the bottom pager. The table owns its copy, so the
// shared "Showing {start} to {end} of {total}" other footers use stays as it is.

/**
 * @param {(key: string, values?: object) => string} text the registry's copy lookup
 * @param {{status: string, firstShown: number, lastShown: number, total: number}} values
 * @returns {string} empty when there is no count to announce
 */
export const countText = (text, { status, firstShown, lastShown, total }) => {
  if (status === 'loading') return text('strTableLoading')
  if (status === 'error') return ''
  if (!total) return text('strTableNoResults')
  return text('strTableShowing', {
    start: firstShown,
    end: lastShown,
    total,
  })
}
